import {
  VIEW_FOLDER,
  VIEW_FOLDER_FAILURE,
  VIEW_FOLDER_SUCCESS,
  UPDATE_VIEW_FOLDERS,
  UPDATE_VIEW_FILES,
  VIEW_VERSION,
  VIEW_VERSION_SUCCESS,
  VIEW_VERSION_FAILURE,
  COPY_LINK,
  COPY_LINK_SUCCESS,
  COPY_LINK_FAILURE,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILURE,
} from "./constants";

export const viewFolder = (payload) => ({
  type: VIEW_FOLDER,
  payload,
});
export const viewFolderSuccess = (payload) => ({
  type: VIEW_FOLDER_SUCCESS,
  payload,
});
export const viewFolderFailure = (payload) => ({
  type: VIEW_FOLDER_FAILURE,
  payload,
});

// Update
export const updateViewFolders = (payload) => ({
  type: UPDATE_VIEW_FOLDERS,
  payload,
});
export const updateViewFiles = (payload) => ({
  type: UPDATE_VIEW_FILES,
  payload,
});

export const viewVersion = (payload) => ({
  type: VIEW_VERSION,
  payload,
});
export const viewVersionSuccess = (payload) => ({
  type: VIEW_VERSION_SUCCESS,
  payload,
});
export const viewVersionFailure = (payload) => ({
  type: VIEW_VERSION_FAILURE,
  payload,
});

export const copyLink = (payload, onCopy) => ({
  type: COPY_LINK,
  payload,
  onCopy,
});
export const copyLinkSuccess = (payload) => ({
  type: COPY_LINK_SUCCESS,
  payload,
});
export const copyLinkFailure = (payload) => ({
  type: COPY_LINK_FAILURE,
  payload,
});

export const downloadFile = (payload, onDownload) => ({
  type: DOWNLOAD_FILE,
  payload,
  onDownload,
});
export const downloadFileSuccess = (payload) => ({
  type: DOWNLOAD_FILE_SUCCESS,
  payload,
});
export const downloadFileFailure = (payload) => ({
  type: DOWNLOAD_FILE_FAILURE,
  payload,
});
